<div class="equipment-size-list-page">
  <form [formGroup]="equipmentSizeForm">
    <mat-card class="no_box_shadow">
      <mat-card-content>
        <div class="example-button-row">
          <h4 class="page-title">Equipment Size</h4>
          <span class="__filter_icon" style="background-color: white;">
          </span>
          @if (addPermission) {
            <a class="__add_client" (click)="openForm()">
              <mat-icon class="__icon">add_circle</mat-icon>
              Create Equipment Size
            </a>
          }
        </div>
        <mat-divider></mat-divider>
        @if (viewPermission) {
          <table mat-table matSort [dataSource]="dataSource" (matSortChange)="sortData($event)" >
            <ng-container matColumnDef="size">
              <th mat-header-cell *matHeaderCellDef class="header">
                <div class="sorting_header">
                  <span mat-sort-header>Equipment Size</span>
                </div>
              </th>
              <td mat-cell *matCellDef="let element">{{element.size}}</td>
            </ng-container>
            <ng-container matColumnDef="noOfTeu">
              <th mat-header-cell *matHeaderCellDef class="header">
                <div class="sorting_header">
                  <span mat-sort-header>No of TEU</span>
                </div>
              </th>
              <td mat-cell *matCellDef="let element">{{element.noOfTeu}}</td>
            </ng-container>
            <ng-container matColumnDef="action">
              <th mat-header-cell *matHeaderCellDef class="header">
                <span>Action</span></th>
                <td mat-cell *matCellDef="let element">
                  @if (editPermission) {
                    <span class="__action_edit_icon" (click)="openForm(element)">
                      <mat-icon mat-cell>create</mat-icon>
                    </span>
                  }
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="groupColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: groupColumns;"></tr>
            </table>
          }

        </mat-card-content>
      </mat-card>
      @if (viewPermission) {
        <mat-paginator [pageSizeOptions]="pageSizeOptions" showFirstLastButtons [length]="totalEquipmentSizeRecords"></mat-paginator>
      }
    </form>
  </div>
